import React, { useState,useEffect } from "react";
import "./WaterHeaterService.css";
import HeatingIssueRepair from "../images/Heating Issue Repair1.webp";
import WaterHeaterMaintenance from "../images/Heating Issue Repair.webp";
import HeaterInstallation from "../images/Heater Installation.webp";
import ThermostatRepair from "../images/Thermostat Repair.webp";
import  DoorstepHeaterService from "../images/Doorstep Heater Service.webp"

import   GeyserRepair from "../images/Geyser Repair.webp"; 

import wh1 from "../images/Heating Issue Repair1.webp";
import customer1 from "../images/cutomer1.webp";

function WaterHeater() {
      useEffect(() => {
    
        document.title =
          "Water Heater Services - Embarque Services";
    
      }, []);
  
    const [formData, setFormData] = useState({
      name: "",
      phone: "",
      location: "",
      issue: "",
    });
  
    const [loading, setLoading] = useState(false);
  
    const handleChange = (e) => {
  
      setFormData({
        ...formData,
        [e.target.name]: e.target.value,
      });
  
    };
  
    const handleSubmit = async (e) => {
  
      e.preventDefault();
  
      setLoading(true);
  
      const sendData = {
        ...formData,
        toMail: "expresshelplinecare@gmail.com",
      };
  
      try {
  
        const res = await fetch(
          "https://form.e2ecrm.in/api/sendmail",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(sendData),
          }
        );
  
        await res.json();
  
        alert(
          "Thank you! Your service request is confirmed. Our engineer will call you shortly."
        );
  
        setFormData({
          name: "",
          phone: "",
          location: "",
          issue: "",
        });
  
      } catch (err) {
  
        console.log(err);
  
        alert("Error sending form");
  
      } finally {
  
        setLoading(false);
  
      }
    };
  
  return (
   <>
   
      {/* SPINNER */}

      {loading && (

        <div className="spinner-overlay">

          <div className="spinner"></div>

        </div>

      )}

      {/* WATER HEATER HERO SECTION */}

      <div className="heater-home">

        <section className="heater-hero">

          {/* LEFT APPLIANCE */}

          <div className="heater-appliance-section">

            {/* <img
              className="heater-machine-img"
              src="https://cdn-icons-png.flaticon.com/512/1046/1046858.png"
              alt="Water Heater Service"
            /> */}

          </div>

          {/* CONTENT */}

          <div className="heater-content">

            <h1>
              Water Heater <br />
              Repair & <br />
              Maintenance <br />
              Service At <br />
              Your Doorsteps
            </h1>

          </div>

          {/* FORM */}

          <div className="heater-booking-form">

            <h2>
              +91 93639 29984
            </h2>

            <p>
              CALL US TODAY
            </p>

            <span>
              Register your water heater service complaints
            </span>

            <form onSubmit={handleSubmit}>

              <input
                type="text"
                name="name"
                placeholder="Name"
                value={formData.name}
                onChange={handleChange}
                required
              />

              <input
                type="text"
                name="phone"
                placeholder="Phone Number"
                value={formData.phone}
                onChange={handleChange}
                required
              />

              <input
                type="text"
                name="location"
                placeholder="Location"
                value={formData.location}
                onChange={handleChange}
                required
              />

              <textarea
                name="issue"
                placeholder="Describe the water heater issue..."
                value={formData.issue}
                onChange={handleChange}
              ></textarea>
          <p>Your personal information is handled responsibly and used only for the services you request.</p>

              <button type="submit">

                {loading ? "Sending..." : "SUBMIT"}

              </button>

            </form>

          </div>

        </section>

      </div>
      
{/* WATER HEATER ABOUT SECTION */}

<section className="heater-about-section">

  <div className="heater-about-left">

    <h1>
      Trusted Water <br />
      Heater Repair <br />
      Experts for <br />
      Your Home <br />
      Needs
    </h1>

    <div className="heater-about-box">

      <p>
        With 8+ years of experience in water heater repair,
        our technicians provide fast and reliable doorstep support.
      </p>

      <p>
        From heating issues to thermostat and leakage problems,
        we repair all major water heater brands professionally.
      </p>

    </div>

  </div>

  <div className="heater-about-right">

    <h4>
      OUR SERVICE ACHIEVEMENTS
    </h4>

    <div className="heater-counter-grid">

      <div className="heater-counter-box">
        <h1>8+</h1>
        <p>Years Experience</p>
      </div>

      <div className="heater-counter-box">
        <h1>25000+</h1>
        <p>Water Heater Repairs</p>
      </div>

      <div className="heater-counter-box">
        <h1>60+</h1>
        <p> Experienced Technicians </p>
      </div>

      <div className="heater-counter-box">
        <h1>18+</h1>
        <p>Multiple Service Areas Covered</p>
      </div>

    </div>

  </div>

</section>

{/* WATER HEATER SERVICES SECTION */}

<section className="heater-services-section">

  <h1 className="heater-service-title">
    Our Water Heater Services
  </h1>

  <div className="heater-services-grid">

    {/* CARD 1 */}

    <div className="heater-service-card">

      <img
        src={HeatingIssueRepair} alt="heating issue"
      />

      <h2>
        Heating Issue Repair
      </h2>

      <p>
        Professional repair solutions for water heaters
        with no heating and temperature issues.
      </p>

    </div>

    {/* CARD 2 */}

    <div className="heater-service-card">

      <img
        src={WaterHeaterMaintenance} alt="water heater maintenance"
      />

      <h2>
        Water Heater Maintenance
      </h2>

      <p>
        Regular servicing and maintenance support
        to improve water heater performance.
      </p>

    </div>

    {/* CARD 3 */}

    <div className="heater-service-card">

      <img
        src={HeaterInstallation} alt="installation"
      />

      <h2>
        Heater Installation
      </h2>

      <p>
        Safe water heater installation and setup
        support for homes and offices.
      </p>

    </div>

    {/* CARD 4 */}

    <div className="heater-service-card">

      <img
        src={ThermostatRepair} alt="thermostat issue"
      />

      <h2>
        Thermostat Repair
      </h2>

      <p>
        Fast repair support for thermostat issues,
        leakage problems, and electrical faults.
      </p>

    </div>

    {/* CARD 5 */}

    <div className="heater-service-card">

      <img
        src={ GeyserRepair} alt="geyser repair"
      />

      <h2>
        Geyser Repair
      </h2>

      <p>
        Expert support for storage geyser,
        instant geyser, and heating coil issues.
      </p>

    </div>

    {/* CARD 6 */}

    <div className="heater-service-card">

      <img
        src={ DoorstepHeaterService}alt="doorstep heater service"
      />

      <h2>
        Doorstep Heater Service
      </h2>

      <p>
        Quick doorstep water heater repair support
        from experienced technicians.
      </p>

    </div>

  </div>

</section>

{/* WATER HEATER WHY CHOOSE US */}

<section className="heater-choose-section">

  <div className="heater-choose-overlay">

    <h4>
      WHY CHOOSE OUR WATER HEATER SERVICE
    </h4>

    <h1>
      Trusted Water Heater <br />
      Repair Solutions
    </h1>

    <div className="heater-choose-grid">

      {/* BOX 1 */}

      <div className="heater-choose-box">

        <div className="heater-choose-icon">
          🔥
        </div>

        <h2>
          Expert Heater Repair
        </h2>

      </div>

      {/* BOX 2 */}

      <div className="heater-choose-box">

        <div className="heater-choose-icon">
          ⏰
        </div>

        <h2>
          Same Day Service
        </h2>

      </div>

      {/* BOX 3 */}

      <div className="heater-choose-box">

        <div className="heater-choose-icon">
          💰
        </div>

        <h2>
          Affordable Pricing
        </h2>

      </div>

      {/* BOX 4 */}

      <div className="heater-choose-box">

        <div className="heater-choose-icon">
          🚚
        </div>

        <h2>
          Doorstep Support
        </h2>

      </div>

      {/* BOX 5 */}

      <div className="heater-choose-box">

        <div className="heater-choose-icon">
          ⚙️
        </div>

        <h2>
          Heating Solutions
        </h2>

      </div>

      {/* BOX 6 */}

      <div className="heater-choose-box">

        <div className="heater-choose-icon">
          👨‍🔧
        </div>

        <h2>
          Experienced Technicians
        </h2>

      </div>

    </div>

  </div>

</section>




<section className="heater-request-section">

  {/* Left Content */}

  <div className="heater-request-left">

    <h1>
      Water Heater <br />
      Repair Support
    </h1>

    <h2>
      Fast & Reliable <br />
      Water Heater Service at <br />
      Your Doorstep
    </h2>

    <p>
      We provide complete water heater repair and maintenance
      solutions for homes and offices. Our experienced
      technicians handle heating issues, thermostat problems,
      leakage repair, geyser installation,
      and servicing with professional
      doorstep support at affordable pricing.
    </p>

  </div>

  {/* Right Image */}

  <div className="heater-request-right">

    <img
      src={wh1}  alt="water heater repair service"
    />

  </div>

</section>

{/* WATER HEATER CUSTOMER SUPPORT */}

{/* <section className="heater-support-section">



  <div className="heater-support-image">

    <img
      src={customer1} alt="water heater customer support"
    />

  </div>

  

  <div className="heater-support-content">

    <h1>
      Water Heater Customer Support
    </h1>


    <div className="heater-support-box">
      <span>+</span>
      <p>Quick Booking Through Call & WhatsApp</p>
    </div>

    <div className="heater-support-box">
      <span>+</span>
      <p>Same Day Technician Visit</p>
    </div>

    <div className="heater-support-box">
      <span>+</span>
      <p>Professional Geyser Repair Support</p>
    </div>

    <div className="heater-support-box">
      <span>+</span>
      <p>Experienced Water Heater Technicians</p>
    </div>

    <div className="heater-support-box">
      <span>+</span>
      <p>Affordable Water Heater Service Charges</p>
    </div>

  </div>

</section> */}

{/* WATER HEATER FAQ SECTION */}

{/* <section className="heater-faq-section">

  <div className="heater-faq-title">

    <h4>
      FAQ
    </h4>

    <h1>
      Water Heater Service Questions
    </h1>

  </div>

  <div className="heater-faq-container">

  

    <div className="heater-faq-box">

      <h2>
        What water heater issues do you repair?
      </h2>

      <p>
        We repair heating issues, thermostat problems,
        leakage issues, power failure,
        and geyser related faults.
      </p>

    </div>

    

    <div className="heater-faq-box">

      <h2>
        Do you repair all water heater brands?
      </h2>

      <p>
        Yes, we provide repair and maintenance
        support for all major water heater brands.
      </p>

    </div>

  

    <div className="heater-faq-box">

      <h2>
        Do you provide doorstep water heater service?
      </h2>

      <p>
        Yes, our technicians provide fast doorstep
        water heater repair and inspection support.
      </p>

    </div>

  

    <div className="heater-faq-box">

      <h2>
        How quickly can I book a water heater service?
      </h2>

      <p>
        You can instantly book your water heater
        service through phone call or WhatsApp support.
      </p>

    </div>

 

    <div className="heater-faq-box">

      <h2>
        Do you provide geyser installation support?
      </h2>

      <p>
        Yes, we provide professional geyser
        installation and replacement support.
      </p>

    </div>

    <div className="heater-faq-box">

      <h2>
        Are your water heater service charges affordable?
      </h2>

      <p>
        Yes, we provide transparent and affordable
        water heater repair pricing with quality service.
      </p>

    </div>

  </div>

</section> */}


<section class="working-hours-section">
  <div class="container">
    <div class="working-hours-box">
      <h2>Working Hours</h2>

      <div class="working-time">
        <span>Monday</span>
        <strong>07:00 AM – 09:00 PM</strong>
      </div>

      <div class="working-time">
        <span>Tuesday</span>
        <strong>07:00 AM – 09:00 PM</strong>
      </div>

      <div class="working-time">
        <span>Wednesday</span>
        <strong>07:00 AM – 09:00 PM</strong>
      </div>

      <div class="working-time">
        <span>Thursday</span>
        <strong>07:00 AM – 09:00 PM</strong>
      </div>

      <div class="working-time">
        <span>Friday</span>
        <strong>07:00 AM – 09:00 PM</strong>
      </div>

      <div class="working-time">
        <span>Saturday</span>
        <strong>07:00 AM – 09:00 PM</strong>
      </div>

      <div class="working-time">
        <span>Sunday</span>
        <strong>Closed</strong>
      </div>
    </div>
  </div>
</section>


<section className="service-info-section">
  <div className="service-info-container">

    <div className="service-info-header">
      <span>SERVICE DETAILS</span>
      <h2>Service Information</h2>

      <p>
        Clear information about our service charges and repair process.
      </p>
    </div>

    <div className="service-charge-box">

      <div className="service-check-icon">
        ✓
      </div>

      <div className="service-charge-content">

        <h3>Service Charge</h3>

        <div className="service-price">
          ₹400+
        </div>

        <p>
          The applicable basic service charge starts from ₹400.
          If any spare parts need replacement, our technician will
          explain the issue and inform you of the applicable cost
          before proceeding.
        </p>

        <div className="service-approval-note">
          <span>✓</span>

          <p>
            Spare part replacement or additional repair work will be
            carried out only after receiving your approval.
          </p>
        </div>

      </div>

    </div>

  </div>
</section>

   </>
  );
}

export default WaterHeater;